import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="footer">
      <Container fluid className="text-center">
        <p className="mb-0 ogs-high-text">© 2025 Omni Group Services. All rights reserved.</p>
      </Container>
    </footer>
  );
}

export default Footer;
